export default (str: string): string => {
  let translatedString = str;

  while (/[aiouye]+([^r])/i.test(translatedString)) {
    translatedString = translatedString.replace(/[aiouey]+([^rR])/g, 'er$1');
    translatedString = translatedString.replace(/[AIOUEY]+([^rR])/g, 'Er$1');
  }

  while (/[aiouy]r/i.test(translatedString)) {
    translatedString = translatedString.replace(/[aiouy]r/gi, 'er');
  }

  return translatedString;
};
